import { AboutNavList, FooterNavList } from "../../utils/constants";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import { useGetAboutMenusQuery, useGetQuickLinksQuery } from "../../api/apiSlice";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import { useAuth } from "../../context/AuthContext";

export default function Footer() {
  const { setAuthModal } = useAuth();
  const {
    data: quickLinksResponse,
    isLoading: loadingQuick,
    isError: errorQuick,
  } = useGetQuickLinksQuery();
  const {
    data: aboutMenusResponse,
    isLoading: loadingAbout,
    isError: errorAbout,
  } = useGetAboutMenusQuery();
  const footerNavs = quickLinksResponse?.quickMenus ?? FooterNavList;
  const aboutNavs = aboutMenusResponse?.aboutMenus ?? AboutNavList;

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerContainer}>
          <div className={styles.buttonSection}>
            <Link className={styles.orangeButton} to="/mentors">
              Find a Mentor
            </Link>
            <button
              onClick={() => setAuthModal({ open: true, tab: "signup" })}
              className={styles.blueButton}
            >
              Become an Research Associate
            </button>
            <button
              onClick={() => setAuthModal({ open: true, tab: "signup" })}
              className={styles.becamepartner}
            >
              Become a Knowledge Partner
            </button>
          </div>

          <div className={styles.footerSection}>
            <h4>Quick Links</h4>
            <ul>
              {loadingQuick ? (
                <Loader />
              ) : errorQuick ? (
                <ErrorMsg />
              ) : (
                footerNavs
                  ?.filter((item) => item.status === 1)
                  .sort((a, b) => a.id - b.id)
                  .map((i) => (
                    <li key={i.id}>
                      <Link to={i.link}>{i.label}</Link>
                    </li>
                  ))
              )}
            </ul>
          </div>

          <div className={styles.footerSection}>
            <h4>About us</h4>
            <ul>
              {loadingAbout ? (
                <Loader />
              ) : errorAbout ? (
                <ErrorMsg />
              ) : (
                aboutNavs
                  ?.filter((item) => item.status === 1)
                  .sort((a, b) => a.id - b.id)
                  .map((i) => (
                    <li key={i.id}>
                      <Link to={i.link}>{i.label}</Link>
                    </li>
                  ))
              )}
            </ul>
          </div>

          <div className={styles.contactUsContainer}>
            <h4>Contact us</h4>
            <div className={styles.contactUs}>
              <p className={styles.location}>
                JK Park Plaza, 212, Alpha-II Commercial Belt, Greater Noida,
                Uttar Pradesh 201310
              </p>
              <p className={styles.phone}>
                <Link to="tel:+91 626 899 1983">+91 626 899 1983</Link>
              </p>
              <p className={styles.email}>
                <Link to="mailto:members.imparc@gmail.com">
                  members.imparc@gmail.com
                </Link>{" "}
                |{" "}
                <Link to="mailto:imparc.gems@gmail.com">
                  imparc.gems@gmail.com
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>&copy; 2025 Impac. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
